import { useCreateUser } from 'users/presentation/hooks/useUserCreate';
import UserForm from '../molecules/UserForm';
import { useEffect, useRef, useState } from 'react';
import { Snackbar } from '../../../../components/atoms/Snackbar/Snackbar';
import { useNavigate } from 'react-router-dom';
import { isAdminRole } from '../../../domain/IRoleRepository';

interface SnackbarHandle {
    showModal: (value: boolean) => void
}

export default function CreateUser() {
    const { createUser, error } = useCreateUser()
    const snackbarRef = useRef<SnackbarHandle>(null)
    const router = useNavigate()
    const [snackbarMessage, setSnackbarMessage] = useState<{
        title: string
        description: string
        state: 'success' | 'error'
    }>({
        title: 'Éxito',
        description: 'Acción completada',
        state: 'success',
    })

    useEffect(() => {
        if (error !== null) {
            setSnackbarMessage({
                title: 'Error',
                description: error,
                state: 'error',
            })
            snackbarRef.current?.showModal(true)
        }
    }, [error])

    const handleFormSubmit = async (data: {
        formData: {
            fullName: string
            email: string
            warehouse: string
            password: string
            confirm_password: string
        }
        role: string
        roleName?: string
        template: number
        file: File | null
    }) => {

      try {
        const isAdmin = data.roleName ? isAdminRole(data.roleName) : false
        const userData = {
          name: data.formData.fullName,
          email: data.formData.email,
          warehouse_id: !isAdmin && data.formData.warehouse
            ? parseInt(data.formData.warehouse)
            : undefined,
          role_id: parseInt(data.role || '0'),
          password: data.formData.password,
          confirm_password: data.formData.confirm_password,
        }
        const newUser = await createUser(userData)

        if (newUser) {
          router('/users', {
            state: {
              title: '¡Éxito!',
              description: 'Usuario creado correctamente',
              state: 'success',
            },
          })
        }
      } catch (e) {
        //console.error(e)
      }

    }

    return (
        <div className="bg-gray-50 py-3">
            <div className="mx-auto">
                <Snackbar
                    ref={snackbarRef}
                    title={snackbarMessage.title}
                    description={snackbarMessage.description}
                    state={snackbarMessage.state}
                    closeAction
                    time={2000}
                />

                <UserForm onSubmit={handleFormSubmit} mode="create" />
            </div>
        </div>
    )
}
